<template>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 pt-5 p-sm-5 mx-auto mt-3 mt-sm-5 cert-page-content">
    <div class="cert-article px-2 px-sm-4">
      <h3 class="mb-4">Malware Attacks</h3>
      <p>
        A malware attack is a common cyberattack where malware (normally malicious software) executes unauthorized
        actions on the victim's system. Motives vary, but cyber attackers mostly focus their tactics, techniques, and
        procedures (TTPs) on gaining access to privileged credentials and accounts in order to carry out their mission.
      </p>

      <h4 class="mt-5 mb-4">Types of Malware Attacks</h4>
      <p>
        Most types of malware fall into one of the following categories:
      </p>
      <ul>
        <li><strong>Viruses:</strong> Once executed, computer viruses can replicate themselves by modifying other
          programs and injecting malicious code. It is the only type of malware that can "infect" other files and is one
          of the most difficult types of malware to remove.
        </li>
        <li><strong>Worms:</strong> Worms quickly spread across networks by replicating themselves and migrating from
          one machine to another without end-user involvement.
        </li>
        <li><strong>Trojans:</strong> Trojan horse malware is one of the most difficult types of malware to detect
          because it disguises itself as a legitimate program. This type of malware contains malicious code and
          instructions and can operate under the radar once executed by the victim. It is often used to infiltrate other
          types of malware into your system.
        </li>
        <li><strong>Adware:</strong> Adware delivers unwanted and aggressive advertisements (such as pop-up ads) to end
          users.
        </li>
        <li><strong>Malvertising:</strong> uses legitimate advertising to deliver malware to end-user computers.</li>
      </ul>

      <h4 class="mt-5 mb-4">How do I know I’ve been infected with malware?</h4>
      <p>
        The most common signs that your computer is infected with malware are:
      </p>
      <ul>
        <li>Your computer is performing poorly</li>
        <li>If your browser is being redirected or your web browser goes to a site, you did not intend to visit</li>
        <li>Often accompanying infection warnings</li>
        <li>Shutting down your computer or Startup Problems</li>
        <li>Common pop-up ads</li>
      </ul>
      <p>
        The more common these symptoms are, the more likely it is that your computer is infected with malware. Browser
        redirects and numerous pop-up warnings claiming to be infected with viruses are the strongest indications that
        your computer has been compromised.
      </p>

      <h4 class="mt-5 mb-4">Steps to take if your organization is already infected by malware</h4>
      <p>
        If your organization is already infected with malware, you can limit its impact by taking the following steps.
      </p>
      <ol>
        <li>Immediately disconnect the infected computer, laptop, or tablet from all wired, wireless, and cellular-based
          network connections.
        </li>
        <li>In extreme cases, consider turning off Wi-Fi, disabling all core network connections (including switches),
          and disconnecting from the Internet.
        </li>
        <li>Reset credentials, including passwords, especially for administrators and other system accounts. But don't
          lock yourself out of the system you need for recovery.
        </li>
        <li>Securely erase the infected device and reinstall the operating system.</li>
        <li>Make sure there is no malware before restoring from backup. You should restore from a backup only if you are
          sure that the backup and the connected device are clean.
        </li>
        <li>Connect your device to a clean network to download, install, and update your operating system and all other
          software.
        </li>
        <li>Install, Update, and Run Antivirus Software</li>
      </ol>

      <h4 class="mt-5 mb-4">How to Prevent Malware Attacks?</h4>
      <p>
        To improve malware protection and detection without impacting business productivity, organizations often take
        the following steps:
      </p>
      <ol>
        <li>Use an antivirus tool to protect against commonly known malware.</li>
        <li>We use endpoint detection and response technologies to continuously monitor and respond to malware attacks
          and other cyber threats against end-user computers.
        </li>
        <li>Follow best practices for patching applications and operating systems (OS).</li>
        <li>Implement the principles of least privilege and just-in-time access to elevate account privileges for
          specifically authorized tasks and keep users productive without granting unnecessary privileges.
        </li>
        <li>Remove local administrator privileges from standard user accounts to reduce the attack surface.</li>
        <li>Greylist applications on user endpoints to prevent unknown applications such as a new instance of ransomware gains the necessary read, write, and modify permissions to access the Internet and encrypt files.</li>
        <li>Apply application whitelisting to servers to maximize security for these assets.</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
